import { isDefAndNotNull } from '@utils/def';
import moment from 'moment';

import { Currency } from 'models/Currency';
import { CurrencyConvention } from 'models/CurrencyConvention';
import { IndexList } from 'models/IndexList';

import { PayFrequency } from '../../../../../../models/PayFrequency';
import { PayFrequencyTypes } from '../../../../../../models/PayFrequency/enum';

export function getDefaultForecastingIndexFromCurrencyConventions(
  currencyId: Currency['currency_id'],
  currencyConventions: CurrencyConvention[],
) {
  const matchedConventions = currencyConventions.filter(
    (currencyConvention) => currencyConvention.currency_id === currencyId,
  );

  return matchedConventions.length
    ? matchedConventions[0].forecasting_index_id
    : null;
}

export function getDefaultDiscountingIndexFromCurrencyConventions(
  currencyId: Currency['currency_id'],
  currencyConventions: CurrencyConvention[],
) {
  const matchedConventions = currencyConventions.filter(
    (currencyConvention) => currencyConvention.currency_id === currencyId,
  );

  return matchedConventions.length
    ? matchedConventions[0].discounting_index_id
    : null;
}

export function getDefaultResetCalendarIdByForecastingIndex(
  forecastingId: number | null,
  irIndexList: IndexList[],
) {
  const matchedCalendar = irIndexList.filter(
    (irIndex) => irIndex.index_id === forecastingId,
  );
  return matchedCalendar.length
    ? matchedCalendar[0].default_calendar_pmca_id
    : null;
}

export function getDefaultCalculationCalendarFromCurrency(
  currencyId: Currency['currency_id'],
  currencies: Currency[],
) {
  const matchedCurrency = currencies.filter(
    (currency) => currency.currency_id === currencyId,
  );

  return matchedCurrency.length
    ? matchedCurrency[0].default_calendar_pmca_id
    : null;
}

export function calculateDate(
  date: string,
  days: number,
  months: number,
  quarters: number,
  years: number,
) {
  return moment(date)
    .add({
      days,
      months,
      quarters,
      years,
    })
    .format('YYYY-MM-DD');
}

export function calculateDateFromPayFrequency(
  payFrequency: null | PayFrequency['pay_frequency_id'],
  date: string | null,
  sign: number,
) {
  if (isDefAndNotNull(date) && isDefAndNotNull(payFrequency)) {
    switch (payFrequency) {
      case PayFrequencyTypes.annual:
        return calculateDate(date, 0, 0, 0, sign);
      case PayFrequencyTypes.semiAnnual:
        return calculateDate(date, 0, 0, sign * 2, 0);
      case PayFrequencyTypes.quarterly:
        return calculateDate(date, 0, 0, sign, 0);
      case PayFrequencyTypes.monthly:
        return calculateDate(date, 0, sign, 0, 0);
      default:
        return null;
    }
  }

  return null;
}
